import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[OnlyDecimal]',
    standalone: false
})
export class OnlyDecimal {
  constructor(private el: ElementRef) {}

  @Input() OnlyDecimal: boolean;

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    let e = <KeyboardEvent>event;
    if (this.OnlyDecimal) {
      if ( 
        [8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 || //190
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return;
      }
      // Ensure that it is a number and stop the keypress
      if (
        e.shiftKey ||
        e.key.charCodeAt(0) < 48 ||
        e.key.charCodeAt(0) > 57 ||
        e.key.charCodeAt(0) == 46 //allow decimal point
        // (e.key.charCodeAt(0) < 96 || e.key.charCodeAt(0) > 105)
      ) {
        e.preventDefault();
      }
    }
  }
}
